// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2hz_q","Open":"SideDrawer_Open__2CISr","Close":"SideDrawer_Close__3p2qj","Logo":"SideDrawer_Logo__2GVD9"};